import React from 'react';
import './LanguagesScreen.css';

const LanguagesScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="languages-screen">
      <h1>Languages</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default LanguagesScreen; 